import { Dispatch, SetStateAction, createContext } from "react";

export type BuddyDetails = {
	name: string;
	email: string;
	profilePicture: string;
};

type BuddyDetailsCtx = {
	detailsLoading: boolean;
	setDetailsLoading: Dispatch<SetStateAction<boolean>>;
	openDetails: boolean;
	setOpenDetails: Dispatch<SetStateAction<boolean>>;
	openConfirm: boolean;
	setOpenConfirm: Dispatch<SetStateAction<boolean>>;
	details?: BuddyDetails;
	setDetails: Dispatch<SetStateAction<BuddyDetails | undefined>>;
	notifyLoading: boolean;
	setNotifyLoading: Dispatch<SetStateAction<boolean>>;
	notifyBuddy: () => Promise<void>;
};

export const BuddyDetailsContext = createContext<BuddyDetailsCtx>({
	detailsLoading: false,
	setDetailsLoading: () => {},
	openDetails: false,
	setOpenDetails: () => {},
	openConfirm: false,
	setOpenConfirm: () => {},
	setDetails: () => {},
	notifyLoading: false,
	setNotifyLoading: () => {},
	notifyBuddy: async () => {},
});
